<div class="title-section">
  @if (stepNumber) {
    <span class="step-number">{{stepNumber}}</span>
  }
  <h1 class="c11n-text-lg-headline margin-bottom-1" data-cy="inputSectionTitle" [innerHTML]="title"></h1>
</div>
@if (subtitle) {
  <p class="c11n-label--medium margin-bottom-2" data-cy="inputSectionSubtitle" [innerHTML]="subtitle">
  </p>
}

<div class="gift-amount-input-container">
  <ng-container [formGroup]="parentForm">
    <label class="input-label" c11n-label for="amount-input">{{ label }}</label>

    <c11n-input [hasError]="amountInputHasError">
      <input c11nInput type="text" id="amount-input" [formControl]="parentForm.controls[controlName]"
        [attr.aria-invalid]="amountInputHasError" aria-describedby="amountInputError" [imask]="inputMask" />
    </c11n-input>
    <c11n-hint-error [hasError]="amountInputHasError" [errorText]="errorMsg" hintErrorId="amountInputError">
    </c11n-hint-error>
  </ng-container>
</div>
